import { icons } from "assets";
import { Tab, TabPanel, Tabs } from "Components/shared/tab";
import TableDisplay from "Components/shared/table";
import Text from "Components/shared/text";
import {
  EmptyComponent,
  Status,
  TransactionType,
} from "Components/shared/transactions";
import React from "react";
import { useGetUsersTransactions } from "services/transactionService";
import { capitalize, convertDate } from "utils/stringServices";
import styles from "./container.module.css";
import { TransactionBodyHeader } from "./TransactionBodyHeader";


const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");
const tableStructure = {
  0: {
    field: "transactionType",
    renderItem: (rowData) => <TransactionType type='debit' />,
    cellStyle: {},
  },
  1: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        {capitalize(rowData.type)}
      </Text>
    ),
    cellStyle: {
      minWidth: "220px",
    },
  },
  2: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        Date:
        <br /> {convertDate(rowData.timestamp)}
      </Text>
    ),
    cellStyle: {
      minWidth: "110px",
    },
  },
  3: {
    renderItem: (rowData) => <Status variant={rowData.status} />,
    cellStyle: {
      textAlign: "left",
    },
  },
  4: {
    renderItem: (rowData) => (
      <Text
        style={{
          display: "flex",
          alignItems: "center",
          justifySelf: "flex-end",
        }}
      >
        ₦{format.format(rowData.amount)}
      </Text>
    ),
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      justifySelf: "flex-end",
      minWidth: "120px",
      flexGrow: 2,
      paddingRight: "24px",
    },
  },
};

export const TransactionBody = () => {
  const [naira, setNaira] = React.useState(true);
  const [dollar, setDollar] = React.useState(false);
  const [euro, setEuro] = React.useState(false);
  const [selectedTab, setSelectedTab] = React.useState(0);
  const handleChange = (e, tabIndex) => {
    setSelectedTab(tabIndex);
  };

  let currency = { naira, dollar, euro };

  const handleActive = (name) => {
    switch (name) {
      case "naira":
        setNaira(true);
        setDollar(false);
        setEuro(false);
        break;
      case "dollar":
        setNaira(false);
        setDollar(true);
        setEuro(false);
        break;
      case "euro":
        setNaira(false);
        setDollar(false);
        setEuro(true);
        break;
      default:
        break;
    }
  };

  const {
    status: transactStatus,
    error: transactError,
    data: transactData,
  } = useGetUsersTransactions("transfer");

  console.log("TRANSACTION ", transactData);

  // fetchUserTransactions

  return (
    <Text tag="div">
      {/* <TransactionBodyHeader handleActive={handleActive} currency={currency} /> */}
      <div className={styles.contentContainer}>
        <Text
          variant="md2"
          tag="h2"
          style={{ fontWeight: "700", marginBottom: "24px" }}
        >
          Transfer Transactions
        </Text>
        <Tabs value={selectedTab} handleChange={handleChange} fullWidth>
          <Tab label="All" />
        </Tabs>
        <TabPanel value={selectedTab} index={0}>
          <TableDisplay
            data={transactData || []}
            column={tableStructure}
            emptyComponent={
              <div className={styles.emptyContainer}>
                <EmptyComponent
                  graphics={
                    <img
                      src={icons.empty_transaction}
                      alt="empty transactions"
                    />
                  }
                  title="Opps! You do not have any transaction history"
                  description="Looks like you do not have any transaction history. Send money to your wallet today to see your transaction history"
                  action={{
                    label: "Go to wallet",
                    onClick: (e) => {},
                    fullWidth: true,
                  }}
                />
              </div>
            }
          />
        </TabPanel>
      </div>
    </Text>
  );
};
